import { Box, Button, Modal, MenuItem, TextField } from "@mui/material";
import { useState } from "react";
import { IBeneficiaryRetificar } from "../../../types";
import { cpfMask } from "utils/cpf";

interface IModalRetificarProps {
  isOpen: boolean;
  onClose: () => void;
  beneficiary: IBeneficiaryRetificar | null;
  onSubmit: (tipoRetificacao: string, observacao: string) => void;
}

export function ModalRetificar({ isOpen, onClose, beneficiary, onSubmit }: IModalRetificarProps) {
  const [tipoRetificacao, setTipoRetificacao] = useState("");
  const [observacao, setObservacao] = useState("");

  const handleSubmit = () => {
    if (!tipoRetificacao || !observacao) return;
    onSubmit(tipoRetificacao, observacao);
    handleClose();
  };

  const handleClose = () => {
    setTipoRetificacao("");
    setObservacao("");
    onClose();
  };

  if (!beneficiary) return null;

  const isFormValid = tipoRetificacao.trim() !== "" && observacao.trim() !== "";

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="modal-retificar-title"
      aria-describedby="modal-retificar-description"
    >
      <Box
        sx={{
          position: "absolute" as "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          height: "auto",
          width: "100%",
          maxWidth: 763,
          bgcolor: "background.paper",
          boxShadow: 24,
          borderRadius: "16px",
          border: "none",
          outline: "none",
        }}
      >
        <Box sx={{ padding: "24px" }}>
          <Box sx={{ marginBottom: "0px" }}>
            <h6 style={{
              padding: "0",
              margin: "0",
              fontSize: "20px",
              lineHeight: "32px",
              letterSpacing: "0.15px",
              fontWeight: 600,
              fontFamily: "Sora, sans-serif",
            }}>
              Retificar
            </h6>
            <p style={{
              fontSize: "16px",
              lineHeight: "24px",
              letterSpacing: "0.15px",
              fontWeight: 400,
              color: "#191C1A",
              margin: "0",
              fontFamily: "Nunito Sans, sans-serif",
            }}>
              Solicite retificacao de dados ao seu cliente.
            </p>
          </Box>
        </Box>

        <Box sx={{ paddingX: "24px", paddingBottom: "24px" }}>
          <Box sx={{
            display: "flex",
            gap: "16px",
            padding: "16px",
            border: "1px solid rgba(0, 0, 0, 0.09)",
            borderRadius: "8px",
            marginBottom: "24px",
          }}>
            <Box sx={{ flex: 1 }}>
              <p style={{
                fontSize: "12px",
                lineHeight: "20px",
                letterSpacing: "0.4px",
                fontWeight: 400,
                color: "rgba(15, 15, 30, 0.6)",
                margin: "0 0 4px 0",
                fontFamily: "Nunito Sans, sans-serif",
              }}>
                Nome
              </p>
              <p style={{
                fontSize: "14px",
                lineHeight: "20px",
                fontWeight: 700,
                color: "rgba(15, 15, 30, 0.6)",
                margin: "0",
                fontFamily: "Nunito Sans, sans-serif",
              }}>
                {beneficiary.nome}
              </p>
            </Box>
            <Box sx={{ flex: 1 }}>
              <p style={{
                fontSize: "12px",
                lineHeight: "20px",
                letterSpacing: "0.4px",
                fontWeight: 400,
                color: "rgba(15, 15, 30, 0.6)",
                margin: "0 0 4px 0",
                fontFamily: "Nunito Sans, sans-serif",
              }}>
                CPF do beneficiario
              </p>
              <p style={{
                fontSize: "14px",
                lineHeight: "20px",
                fontWeight: 700,
                color: "rgba(15, 15, 30, 0.6)",
                margin: "0",
                fontFamily: "Nunito Sans, sans-serif",
              }}>
                {cpfMask(beneficiary.cpfBeneficiario)}
              </p>
            </Box>
            <Box sx={{ flex: 1 }}>
              <p style={{
                fontSize: "12px",
                lineHeight: "20px",
                letterSpacing: "0.4px",
                fontWeight: 400,
                color: "rgba(15, 15, 30, 0.6)",
                margin: "0 0 4px 0",
                fontFamily: "Nunito Sans, sans-serif",
              }}>
                CPF do titular
              </p>
              <p style={{
                fontSize: "14px",
                lineHeight: "20px",
                fontWeight: 700,
                color: "rgba(15, 15, 30, 0.6)",
                margin: "0",
                fontFamily: "Nunito Sans, sans-serif",
              }}>
                {cpfMask(beneficiary.cpfTitular)}
              </p>
            </Box>
          </Box>

          <TextField
            select
            fullWidth
            label="Tipo da retificacao"
            value={tipoRetificacao}
            onChange={(e) => setTipoRetificacao(e.target.value)}
            sx={{ marginBottom: "24px" }}
            InputLabelProps={{
              style: {
                fontSize: "12px",
                fontFamily: "Nunito Sans, sans-serif",
                color: "rgba(15, 15, 30, 0.6)",
              }
            }}
            InputProps={{
              style: {
                fontSize: "16px",
                fontFamily: "Nunito Sans, sans-serif",
              }
            }}
          >
            <MenuItem value="dados_pessoais">Dados pessoais</MenuItem>
            <MenuItem value="dados_contratuais">Dados contratuais</MenuItem>
            <MenuItem value="documentacao">Documentacao</MenuItem>
            <MenuItem value="plano">Plano</MenuItem>
            <MenuItem value="outros">Outros</MenuItem>
          </TextField>

          <TextField
            fullWidth
            multiline
            rows={4}
            label="Observacao"
            value={observacao}
            onChange={(e) => setObservacao(e.target.value)}
            InputLabelProps={{
              style: {
                fontSize: "12px",
                fontFamily: "Nunito Sans, sans-serif",
                color: "rgba(15, 15, 30, 0.6)",
              }
            }}
            InputProps={{
              style: {
                fontSize: "16px",
                fontFamily: "Nunito Sans, sans-serif",
              }
            }}
          />
        </Box>

        <Box sx={{
          display: "flex",
          gap: "8px",
          alignItems: "center",
          justifyContent: "flex-end",
          padding: "24px",
        }}>
          <Button
            variant="outlined"
            color="error"
            onClick={handleClose}
            sx={{
              paddingX: "16px",
              paddingY: "6px",
              borderRadius: "8px",
              fontSize: "14px",
              lineHeight: "24px",
              letterSpacing: "0.4px",
              fontWeight: 600,
              fontFamily: "Sora, sans-serif",
              textTransform: "none",
            }}
          >
            Cancelar
          </Button>
          <Button
            variant="contained"
            onClick={handleSubmit}
            disabled={!isFormValid}
            sx={{
              paddingX: "16px",
              paddingY: "6px",
              borderRadius: "8px",
              fontSize: "14px",
              lineHeight: "24px",
              letterSpacing: "0.4px",
              fontWeight: 600,
              fontFamily: "Sora, sans-serif",
              textTransform: "none",
            }}
          >
            Solicitar retificacao
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
